import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IAttachment } from 'app/request-form/_models/attachment.interface';
import { RequestInformationViewModel } from 'app/request-form/_models/request-information.view-model';

@Component({
  selector: 'app-request-information',
  templateUrl: './request-information.component.html',
  styleUrls: ['./request-information.component.scss'],
  standalone: false,
})
export class RequestInformationComponent implements OnInit {
  @Input() viewModel: RequestInformationViewModel;
  @Output() clickItem = new EventEmitter<IAttachment>();

  constructor() {}

  ngOnInit() {}

  /**
   * Method called when attachment is clicked to download
   * @param attachment attachment clicked from attachment list
   */
  clickAttachment(attachment: IAttachment): void {
    this.clickItem.emit(attachment);
  }
}
